<div class="auth-button">
  <ng-container *ngIf="user$ | async; else notLogged">
    <div class="d-flex align-items-center">
      <app-avatar
        class="cursor"
        role="button"
        (click)="toggleIsProfileNavigationOpen()"
        (clickOutside)="isProfileNavigationOpen = false"
      >
        <app-desktop-navigation-dropdown
          (logout)="logout.emit()"
          *ngIf="isProfileNavigationOpen"
          (closeDropdown)="isProfileNavigationOpen = false"
        ></app-desktop-navigation-dropdown>
      </app-avatar>
    </div>
  </ng-container>
  <ng-template #notLogged>
    <app-button
      [buttonStyle]="BUTTON_STYLES.ACTION"
      [buttonSize]="'medium'"
      [routerLink]="'/auth'"
    >
      {{ "sign_in" | t }}
    </app-button>
  </ng-template>
</div>
